import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'waitListCalculation',
  standalone: false,
})
export class WaitListCalculationPipe implements PipeTransform {
  transform(limitPatients: number, multiplier: number = 4, openHours: number = 8): number {
    return limitPatients * multiplier * openHours
  }
}
